(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activity-tiles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initActivityCarousel(carousel) {
      if (!carousel || carousel.dataset.initialized === 'true') return;

      carousel.dataset.initialized = 'true';

      const slides = Array.from(carousel.querySelectorAll('[data-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-dot]'));
      const prevButton = carousel.querySelector('[data-prev]');
      const nextButton = carousel.querySelector('[data-next]');
      const pauseButton = carousel.querySelector('[data-pause]');
      const pauseIcon = carousel.querySelector('[data-pause-icon]');

      if (slides.length < 2) return;

      let currentIndex = 0;
      let timer = null;
      let paused = false;

      const autoplay = carousel.dataset.autoplay === 'true';
      const speed = parseInt(carousel.dataset.speed, 10) || 5000;

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      function showSlide(index) {
        if (index >= slides.length) index = 0;
        if (index < 0) index = slides.length - 1;

        currentIndex = index;

        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === currentIndex;

          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');

          if (dots[slideIndex]) {
            dots[slideIndex].classList.toggle('is-active', active);
            dots[slideIndex].setAttribute(
              'aria-current',
              active ? 'true' : 'false'
            );
          }
        });
      }

      function nextSlide() {
        showSlide(currentIndex + 1);
      }

      function prevSlide() {
        showSlide(currentIndex - 1);
      }

      function stopTimer() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function startTimer() {
        stopTimer();

        if (!autoplay || paused || reducedMotion) return;

        timer = window.setInterval(nextSlide, speed);
      }

      function resetTimer() {
        startTimer();
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          nextSlide();
          resetTimer();
        });
      }

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          prevSlide();
          resetTimer();
        });
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          showSlide(parseInt(dot.dataset.index, 10));
          resetTimer();
        });
      });

      if (pauseButton) {
        pauseButton.addEventListener('click', () => {
          paused = !paused;

          pauseButton.setAttribute(
            'aria-label',
            paused ? 'Play slideshow' : 'Pause slideshow'
          );

          if (pauseIcon) {
            pauseIcon.textContent = paused ? '▶' : 'Ⅱ';
          }

          if (paused) {
            stopTimer();
          } else {
            startTimer();
          }
        });
      }

      carousel.addEventListener('mouseenter', stopTimer);
      carousel.addEventListener('mouseleave', startTimer);

      carousel.addEventListener('focusin', stopTimer);

      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) {
          startTimer();
        }
      });

      showSlide(0);
      startTimer();
    }

    function initAllActivityCarousels(root = document) {
      root.querySelectorAll('[data-activity-carousel]').forEach((carousel) => {
        initActivityCarousel(carousel);
      });
    }

    initAllActivityCarousels();

    document.addEventListener('shopify:section:load', (event) => {
      initAllActivityCarousels(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
